import { createRoot } from 'react-dom/client'
import { App } from '@/components/App'
import { Toaster } from '@/components/ui/sonner'
import { SessionProvider } from '@/lib/session-context'
import { ActivationProvider } from '@/lib/activation-context'
import { DealPipelineProvider } from '@/lib/deal-pipeline-provider'

function initReactApp() {
  const container = document.getElementById('react-root')
  if (!container) return

  const bootstrap = window.__SENTINEL__ ?? { currentUser: null, csrfToken: null }
  createRoot(container).render(
    <SessionProvider initial={bootstrap}>
      <ActivationProvider>
        <DealPipelineProvider>
          <App />
          <Toaster position="top-center" richColors />
        </DealPipelineProvider>
      </ActivationProvider>
    </SessionProvider>,
  )
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReactApp)
} else {
  initReactApp()
}
